<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-12-29 18:40:06
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-01-15 17:01:40
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <DetailTopPart v-if="id" :orderId="id"></DetailTopPart>
      <OrderLand v-if="id" :orderId="id" :fromType="from_type"></OrderLand>
    </div>
  </el-main>
</template>

<script>
import DetailTopPart from "./components/DetailTopPart";
import OrderLand from "./components/OrderLand";
export default {
  name: "FarmingOrderSettleDetail",
  components: {
    DetailTopPart,
    OrderLand,
  },
  data() {
    return {
      id: "",
      from_type: "",
    };
  },
  mounted() {
    let { id, from_type } = this.$route.query;
    this.id = id;
    this.from_type = from_type;
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
</style>
